import { TYearScreenCode } from '@/services';
import {
	CommonActions,
	CommonSelectors,
	useAppDispatch,
	useAppSelector,
} from '@/stores';
import { useEffect, useMemo } from 'react';

import { DefaultOptionType } from 'antd/es/select';

import { map, reverse } from 'ramda';

export const useYearList = (screenCode?: TYearScreenCode) => {
	const dispatch = useAppDispatch();
	const yearList = useAppSelector(CommonSelectors.yearRegisterList);

	const selectList = useMemo(() => {
		if (screenCode && yearList[screenCode]) {
			const data = map(
				(year: number) =>
					({
						value: String(year),
						label: String(year),
					}) as DefaultOptionType,
				reverse([...(yearList[screenCode]?.data || [])])
			);
			return {
				data,
				fetching: yearList[screenCode].fetching,
			};
		}
		return { fetching: false, data: [] };
	}, [yearList, screenCode]);

	useEffect(() => {
		if (screenCode) {
			dispatch(CommonActions.getYearRegisterListRequest({ screenCode }));
		}
	}, [screenCode]);

	return selectList;
};
